import clsx from 'clsx';
import { RadioCheckedIcon, RadioUncheckedIcon } from '../../../../../../shared/ui/icons';
import styles from '../BasicInformationCard.module.css';

export function RadioCardGroup({ label, ariaLabel, options, value, onChange }) {
  return (
    <div className={clsx(styles.radioCardGroup)}>
      <div className={clsx(styles.label)}>{label}</div>
      <div
        className={clsx(styles.radioCardOptions)}
        role="radiogroup"
        aria-label={ariaLabel ?? label}
      >
        {options.map((option) => {
          const isSelected = option.value === value;
          const RadioIcon = isSelected ? RadioCheckedIcon : RadioUncheckedIcon;

          return (
            <button
              key={option.value}
              type="button"
              role="radio"
              aria-checked={isSelected}
              className={clsx(styles.radioCardOption, isSelected && styles.radioCardOptionActive)}
              onClick={() => onChange(option.value)}
            >
              <RadioIcon className={clsx(styles.radioIcon)} aria-hidden />
              <span>{option.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
